<template>
    <div>
        <div v-if="userFeedback.message && positionIsTop" class="feedback feedback-bottom">{{ userFeedback.message }}</div>
        <slot></slot>
        <div v-if="userFeedback.message && positionIsBottom" class="feedback-container feedback-container-below-message">
            <div class="arrow arrow-pointing-up"></div>
            <div class="feedback">{{ userFeedback.message }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "user-feedback",
        props: {
            userFeedback: {
                type: Object,
                default: {
                    message: '',
                    position: 'top'
                }
            }
        },
        computed: getComputed()
    }

    function getComputed(){
        return {
            positionIsTop: positionIsTop,
            positionIsBottom: positionIsBottom
        }

        function positionIsTop(){
            return this.userFeedback.position === undefined
                ||this.userFeedback.position === ''
                || this.userFeedback.position === 'top';
        }

        function positionIsBottom(){
            return this.userFeedback.position === 'bottom';
        }
    }
</script>

<style scoped lang="scss">

    $feedback-background-color: rgb(105, 205, 195);

    .feedback-container {
        margin: 0;

        &-below-message {
            margin-top: -10px;
            margin-bottom: 7px;
        }

        &above-message {
            margin-top: 7px;
            margin-bottom: -10px;
        }
    }

    .feedback {
        background-color: $feedback-background-color;
        color: white;
        border-width: 1px;
        border-radius: 3px;
        padding: 5px 10px 4px 10px;
        max-width: none;
        width: auto;
    }

    .arrow {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        margin: 0 auto;

        &-pointing-down {
            border-top: 5px solid $feedback-background-color;
         }

        &-pointing-up {
            border-bottom: 5px solid $feedback-background-color;
        }
    }
</style>